<style>
@import "/src/assets/tailwind.css";
@import "/src/assets/main.css";
</style>
<template>
  <router-view></router-view>
</template>
